import { Component, Input, OnInit } from '@angular/core';
import { FeecappingRules } from '@app/core/models/journey/enum/tariff-rule.enum';
import { Tap } from '@app/core/models/journey/tap';

@Component({
  selector: 'pp-tap-fare',
  templateUrl: './tap-fare.component.html',
  styleUrls: ['./tap-fare.component.css']
})
export class TapFareComponent implements OnInit {

  @Input() tap: Tap;

  @Input() journeyFeeCappingStatus: string;

  @Input() displayDetailedMode: boolean;

  feeCappingRules = FeecappingRules.feeCappingRules;

  ngOnInit(): void {
  }

}
